/**
 * Single FAQ article (deep link from email or chat).
 * @viewport both
 */
import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Breadcrumbs, Button, Link, Typography } from '@mui/material';
import HelpPublicLayout from '@/features/help/components/HelpPublicLayout';
import { getFaqBySlug, AUTH_HELP_PATHS } from '@/features/help/helpContent';

const HelpFaqArticlePage = () => {
  const { slug } = useParams();
  const item = getFaqBySlug(slug);

  if (!item) {
    return (
      <HelpPublicLayout title="Question not found">
        <Typography variant="body1" paragraph>
          This FAQ link may be outdated.
        </Typography>
        <Button component={RouterLink} to={AUTH_HELP_PATHS.faq} variant="contained">
          Browse all FAQ
        </Button>
      </HelpPublicLayout>
    );
  }

  return (
    <HelpPublicLayout title={item.question}>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component={RouterLink} to={AUTH_HELP_PATHS.hub} underline="hover" color="inherit">
          Help
        </Link>
        <Link component={RouterLink} to={AUTH_HELP_PATHS.faq} underline="hover" color="inherit">
          FAQ
        </Link>
        <Typography color="text.secondary">{item.category}</Typography>
      </Breadcrumbs>

      <Typography variant="body1" paragraph>
        {item.answer}
      </Typography>

      <Button component={RouterLink} to={AUTH_HELP_PATHS.faq} variant="outlined" sx={{ mt: 2 }}>
        All questions
      </Button>
    </HelpPublicLayout>
  );
};

export default HelpFaqArticlePage;
